import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap'; // Optional: If you're using React Bootstrap
import './navigationWrapper.css'; // Import the CSS file
import '../../pages/profiles/tanProfiles.css'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setCssVariables } from '../../logic/cssVariables';
import { useNavigationManager } from '../../logic/nextNav';

const NavigationWrapper = ({ onPrevious, onNext, preventProceed, triggerNavigate, children, hideNext, finalize, hideFooter }) => {
  const { t } = useTranslation("translation", { keyPrefix: "navigationWrapper" });
  const { currentIndex, prevIndex, navigate, sessionSelection } = useNavigationManager();
  const tanProfile = useSelector((state) => state?.tanProfile)
  // const sessionTypes = tanProfile?.profileMeta?.sessionTypes
  // const sessionOptions = useSelector(getSessionOptions)
  // const sessionOptions = {}
  
  // just defines what order the routes are in.
  // could probably just determine it based on what's available 
  // in the moment but I like this so leave me alone.
  

  let style = "tan"
  document.documentElement.style.setProperty('--popover-style', style)
  const styleWellfit = () => {
    style = "wellfit"
    document.documentElement.style.setProperty('--navigation-background', "linear-gradient(to bottom, white 20%, var(--wellfit-balance-green) 80%)")
    document.documentElement.style.setProperty('--navigation-h1-font', "#57585a")
    document.documentElement.style.setProperty('--popover-style', style)
  }
  const styleTan = () => {
    style = "tan"
    document.documentElement.style.setProperty('--navigation-background', "linear-gradient(to bottom, var(--unity-primary-blue) -30%, var(--unity-secondary-violet) 80%)")
    document.documentElement.style.setProperty('--navigation-h1-font', "white")
    document.documentElement.style.setProperty('--popover-style', style)
  }
  // Did this at one point to allow styling changes in navigation. Then they wanted the water bg, so ¯\_(ツ)_/¯
  // switch (locationParts.segment2) {
  //   case "WellFit":
  //     styleWellfit()
  //     break
  //   case "scents":
  //     if (sessionOptions.WellFit) {
  //       styleWellfit()
  //     } else {
  //       styleTan()
  //     }
  //     break
  //   default:
  //     styleTan()
  //     break
  // }
  
  useEffect(() => { setCssVariables() }, [])

  // useEffect(() => {
  //   if (triggerNavigate) {
  //     if (triggerNavigate === "next") {
  //       navigate(true)
  //     } else {
  //       navigate(false)
  //     }
  //   }
  // }, { triggerNavigate })
  


  return (
    <div className='nav-wrapper profiles-container'>
      <div className='children-container'>{children}</div>
      {sessionSelection && !hideFooter && <div className="footer">
        {prevIndex < currentIndex ? <Button variant="primary" onClick={() => {
          onPrevious && onPrevious()
          navigate(false)
        }} className={`footer-button ` + (style === 'tan' ? "tan-style-button" : "wellfit-style-button")}>
          {t("buttons.previous", "Previous")}
        </Button> : <div></div>}
        {!hideNext && <Button variant="primary" onClick={() => {
          onNext && onNext();
          !preventProceed && navigate(true)
        }} className={`footer-button ` + (style === 'tan' ? "tan-style-button" : "wellfit-style-button")}>
          {t("buttons.next", "Next")}
        </Button>}
      </div>}
    </div>

  );
};

export default NavigationWrapper;
